import script from "./BaseTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTooltip.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTooltip.vue?vue&type=style&index=0&id=8999a380&lang=scss"

const __exports__ = script;

export default __exports__